__turbopack_context__.v({
  "className": "inter_e85172d5-module__rFgRPG__className",
});
